<template>
    <div :class="{uploaded: withPreview && uploaded}"
         class="w-100 d-flex align-items-center justify-content-flex-start">
        <x-modal class="slim-modal" :dropzone="true" :loading="uploading" width="500"
                 v-if="showDocumentUploadModal && modal" @close="closeUpload" @cancel="closeUpload" @ok="submitForm"
                 :okDisabled="!hasFiles">
            <div slot="title" :class="`d-flex justify-content-between align-items-center`">
                Upload Document
            </div>
            <slim-multi
                :submitPressed="submitPressed"
                @uploading="uploadingStatus"
                @success="closeModalSuccessful"
                @fail="closeModalFailed"
                @hasFiles="checkHasFiles"
                @fileNames="filenames"
                default-input-name="file"
                :options="slimOptions"
                :extraFields="extraFields"
                :endpoint="endpoint"
                :label="label">
            </slim-multi>
        </x-modal>
        <a :class="'btn btn-success'"
           style="width: 180px; margin-right: 15px; min-width: 150px;"
           v-if="modal"
           @click.prevent.stop="openModal"
           v-b-tooltip.hover
           :title="uploadButtonText"
           :disabled="successful">
            {{ uploadButtonText }}
        </a>
        <div class="files" v-if="files.length > 0">
            <el-tag size="medium" v-for="file, index in files" :key="index">{{ file }}</el-tag>

            <i class="fas fa-check text-success"></i>
        </div>
        <slim-multi
            v-if="!modal"
            :submitPressed="submitPressed"
            @uploading="uploadingStatus"
            @success="closeModalSuccessful"
            @fail="closeModalFailed"
            @hasFiles="checkHasFiles"
            default-input-name="file"
            :options="slimOptions"
            :extraFields="extraFields"
            :endpoint="endpoint">
        </slim-multi>
    </div>
</template>

<script>
import XModal from '@shared/components/modal/Modal.vue'
import {Message} from "element-ui";

export default {
    name: 'file-upload',
    components: {
        XModal,
    },
    props: {
        endpoint: {
            type: String,
            required: true
        },
        placeholder: {
            type: String,
            required: false,
            default: ''
        },
        label: {
            type: String,
            required: false,
            default: 'Drop files here <b><em>or</em></b> <span style="text-decoration: underline;">click to browse</span>'
        },
        modal: {
            type: Boolean,
            default: false
        },
        uploadTriggerText: {
            default: 'Upload New',
        },
        extraFields: {
            required: false
        },
        withPreview: {
            required: false,
            default: false
        },
        document: {
            required: false,
        }
    },
    data() {
        return {
            showDocumentUploadModal: false,
            uploading: false,
            uploaded: false,
            submitPressed: false,
            pdf: {},
            hasFiles: false,
            files: [],
            slimOptions: {
                initialImage: this.placeholder,
                jpegCompression: 30,
                dataRatio: 'free',
                buttonEditLabel: '<i class="el-icon-edit-outline"></i>',
                buttonUploadLabel: '<i class="el-icon-upload"></i>',
                buttonRemoveLabel: '<i class="el-icon-document-delete"></i>',
                post: 'output',
                forceType: 'jpg',
                label: this.label,
                size: '2480, 3508',
                meta: this.extraFields
            },
            successful: false
        }
    },
    computed: {
        uploadButtonText() {
            return (this.successful ? this.successful : this.uploadTriggerText);
        }
    },
    watch: {},
    mounted() {
        if (this.document && this.document.file_name) {
            this.files.push(this.document.file_name)
        }
    },
    updated() {
    },
    activated() {
    },
    methods: {
        closeUpload() {
            this.showDocumentUploadModal = false;
            this.hasFiles = false;
        },
        checkHasFiles(data) {
            this.hasFiles = data;
        },
        filenames(data) {
            this.files = data;
        },
        submitForm() {
            this.submitPressed = true;
        },
        openModal() {
            this.showDocumentUploadModal = true;
        },
        closeModal() {
            this.uploadTriggerText = "Successful Upload";
            this.showDocumentUploadModal = false;
        },
        closeModalSuccessful() {
            this.successful = "Successful Upload";

            setTimeout(() => {
                this.successful = false;
            }, 2000);

            this.submitPressed = false;
            this.hasFiles = false;
            this.closeModal();
        },
        closeModalFailed() {
            this.successful = "Failed Upload";
            Message({message: "There was an error during upload, please try again.", type: "error"})
            setTimeout(() => {
                this.successful = false;
            }, 2000);

            this.submitPressed = false;
            this.hasFiles = false;
            this.closeModal();
        },
        uploadingStatus(data) {
            this.uploading = data;
        }
    }
}
</script>

<style lang="scss" scoped>
section {
    width: 100%;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;

    &.uploaded {
        display: block;
    }

    .slim {
        width: 100%;
    }
}

.slim-btn {
    font-size: 1em;
    background-image: none;
}

.btn-success {
    &[disabled] {
        background-color: #fff;
        background-color: #fff;
        color: #28a744 !important;
    }
}

.document {
    height: 20rem;
    background-repeat: no-repeat;
    background-size: contain;
    background-position: center center;
}
</style>

<style lang="scss">
.slim-modal {
    .modal-body {
        overflow: hidden;
        overflow-y: scroll;
        max-height: 65vh;
        -ms-overflow-style: none;

        &::-webkit-scrollbar {
            display: none;
        }
    }
}
</style>
